import { useNavigation } from "@react-navigation/core";
import * as Clipboard from "expo-clipboard";
import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  Dimensions,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { FormattedMessage } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";

import { styles } from "./styles";

import AsyncStorage from "@react-native-async-storage/async-storage";
import QRCode from "react-native-qrcode-svg";
import GradientButton from "../../components/GradientButton";
import paymentService from "../../services/paymentService";
import formatDate from "../../utils/formatDate";
import { formatCoin } from "../../utils/formatNumber";
import toast from "../../utils/toast";

const DepositPix = () => {
  const navigation = useNavigation();

  const [value, setValue] = useState(0);
  const [pixCode, setPixCode] = useState("");
  const [expirationDate, setExpirationDate] = useState();

  useEffect(() => {
    async function createPixPayment() {
      const value = parseFloat(await AsyncStorage.getItem("depositAmount"));
      setValue(value);
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      try {
        const response = await paymentService.createPix(token, value);
        const { pix_code, expiration_date } = response.data;
        console.log(response.data);
        setPixCode(pix_code);
        setExpirationDate(expiration_date);
      } catch (err) {
        console.log(err.response.data);
        if (err.response?.data?.message)
          toast(err.response.data.message, "#DA1414");
        else
          toast(intl.formatMessage({ id: "depositPix.erroGeral" }), "#DA1414");
        navigation.navigate("Home");
      }
    }
    createPixPayment();
  }, []);

  const [copied, setCopied] = useState(false);
  function copyToClipboard() {
    Clipboard.setString(pixCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  const screenSize = Dimensions.get("screen");

  return (
    <View style={{ flex: 1 }}>
      <HeaderTabs
        title={<FormattedMessage id="depositPix.titlePix" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="depositPaymentMethod.depositePix" />
          </Text>
        }
      />
      <View>
        {!pixCode ? (
          <View style={styles.activityIndicatorContainer}>
            <ActivityIndicator
              color="#2797A2"
              size="large"
              style={styles.activityIndicator}
            />
          </View>
        ) : (
          <View style={styles.container}>
            <View>
              <View style={styles.headerInfo}></View>
              <View>
                <Text style={styles.title}>
                  <FormattedMessage id="depositPix.txtPix" />
                </Text>
                <Text style={styles.value}>
                  <FormattedMessage id="depositPix.txtSiglaMoeda" />
                  {formatCoin(value)}
                </Text>
              </View>
              <View style={styles.qrCodeContainer}>
                <QRCode value={pixCode} size={screenSize.width * 0.2} />
              </View>

              <View style={styles.codeContainer}>
                <View style={styles.codeHeader}>
                  {/* <Text style={styles.bold}>
                    <FormattedMessage id="depositPix.txtCodigo"/>
                  </Text> */}
                </View>
                <View style={styles.pixCodeContainer}>
                  <Text
                    style={{
                      textAlign: "center",
                      width: "90%",
                      flexWrap: "wrap",
                    }}
                  >
                    {pixCode}
                  </Text>
                  <TouchableOpacity
                    style={{ marginLeft: 4 }}
                    onPress={copyToClipboard}
                  >
                    <Text style={styles.copyText}>
                      {copied ? "Copiado!" : "Copiar"}
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
              <View style={styles.dateContainer}>
                <Text style={styles.bold}>
                  <FormattedMessage id="depositPix.txtValidade" />
                  {expirationDate && formatDate(expirationDate)}
                </Text>
                <Text style={styles.bold}></Text>
              </View>
            </View>

            <View style={styles.guiaContainer}>
              <Text style={styles.explanationText}>
                <FormattedMessage id="depositPix.abraAppOuBanco" />
              </Text>

              <Text style={styles.explanationText}>
                <FormattedMessage id="depositPix.copieECole" />
              </Text>

              <Text style={styles.explanationText}>
                <FormattedMessage id="depositPix.confirmEmail" />
              </Text>

              <Text style={styles.explanationText}>
                <FormattedMessage id="depositPix.txtPixPodeDemorar" />
              </Text>
            </View>

            <View style={styles.infoBottomContainer}>
              <Text style={styles.explanationTextBottom}>
                <FormattedMessage id="depositPix.sePagNaoEfetuado" />
              </Text>{" "}
              {"\n"}
              <Text style={styles.explanationTextBottom}>
                <FormattedMessage id="depositPix.naoAceitamosTereiros" />
              </Text>{" "}
              {"\n"}
            </View>

            <View style={{ alignSelf: "center", minWidth: 320 }}>
              <TouchableOpacity
                onPress={() => navigation.navigate("Home")}
                style={styles.actionButton}
              >
                <Text style={styles.actionButtonText}>
                  <FormattedMessage id="depositPix.txtFinalizar" />
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        )}
      </View>
    </View>
  );
};

export default DepositPix;
